import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

interface LoaderProps {
  size?: number;
  /** Fills the parent and centres the spinner — used for full-panel loading. */
  fullHeight?: boolean;
}

/** Centred spinner. The legacy `.CustLodder`/`.circular-loader` classes are kept
 * so the ported LESS continues to position it the same way. */
const Loader = ({ size = 40, fullHeight = false }: LoaderProps) => (
  <div
    className={fullHeight ? 'CustLodder circular-loader' : 'CustLodder'}
    data-testid='loader'
  >
    <Box className='CustLodder' padding={1}>
      <Box sx={{ textAlign: 'center' }}>
        <CircularProgress size={size} />
      </Box>
    </Box>
  </div>
);

export default Loader;
